import fr from './fr.json';
import en from './en.json';
import jp from './jp.json';

export const dictionaryList = { en, fr, jp };

export const languageOptions = {
  en: 'English',
  fr: 'Français',
  jp: '日本語'
};